import { PortalLeftSidebar } from './PortalLeftSideBar';
import { PortalMain } from '../PortalApplication/PortalMain';

import './PortalApplication.css';

// This portal app does not need to host router. It is the dashboard and helps to redirects to other application.
// This Component only describes the layout of this dashboard app. 1 header, 1 sidebar and content in the right.

export function PortalApplication() {
  return (
    <div className='portal'>
      <PortalLeftSidebar />
      <PortalMain />
    </div>
  );
}
